export default "__VITE_PUBLIC_ASSET__16834d9a__"